import {
  Flex,
  InputGroup,
  Select,
  SelectProps,
  TagLabel,
  useBreakpointValue
} from "@chakra-ui/react";
import { IoMdArrowDropdown } from "react-icons/io";

interface StyledSelectProps extends SelectProps {
  placeholder?: string;
}

export function StyledSelect({ placeholder, children, ...rest }: StyledSelectProps) {
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  return (
    <Flex
      as="label"
      flex="1"
      paddingY={["10px", "4"]}
      paddingX={["0", "4"]}
      pl={!isWideVersion && "10px"}
      marginLeft={["0", "6"]}
      alignSelf="center"
      alignItems="center"
      color="gray.200"
      position="relative"
      bg="white"
      maxWidth={400}
      h={["36px", "48px"]}
      transform="skew(-20deg)"
      className={!isWideVersion && "no-icon"}
      sx={
        !isWideVersion && {
          ".chakra-select": {
            paddingRight: "0px"
          }
        }
      }
    >
      <Select
        {...rest}
        variant="unstyled"
        h="full"
        icon={<IoMdArrowDropdown />}
        iconColor="blue.500"
        color="gray.700"
        bg="white"
        pl={!isWideVersion && "5px"}
        pr={!isWideVersion && "0"}
        borderRadius="0"
        fontSize={["text1", "text1"]}
        placeholder={placeholder}
        cursor="pointer"
      >
        {children}
      </Select>
    </Flex>
  );
}

interface selectProps extends SelectProps {
  tag?: string;
  ph?: string;
  customWidth?: string | string[];
}

export function SelectWithLabel({ children, tag, ph, customWidth, ...rest }: selectProps) {
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  return (
    <InputGroup
      display="flex"
      flexDirection="column"
      width="100%"
      alignItems="flex-start"
      position="relative"
    >
      <TagLabel
        position="absolute"
        color="gray.300"
        fontSize={isWideVersion ? "14px" : "12px"}
        top="-8px"
        left="10px"
        backgroundColor="white"
        zIndex="99"
        p="0 5px"
      >
        {tag}
      </TagLabel>

      <Select
        {...rest}
        borderColor="gray.300"
        borderRadius="0"
        width={customWidth ? customWidth : "100%"}
        placeholder={ph}
        focusBorderColor="gray.800"
        _hover={{ borderColor: "green.900" }}
        height="53px"
        sx={{ ".intoOption": { color: "blue.900" } }}
        color="blue.900"
        cursor="pointer"
      >
        {children}
      </Select>
    </InputGroup>
  );
}
